import { makeVar } from '@apollo/client/cache'
import {
    AdminBaseRoles,
    Role,
} from '@deltek/specification-client/core/Configurations/Authorization'
import { CurrentUserInfo } from '@deltek/specification-client/core/Models/currentUserInfo'

export interface UserInfo {
    currentUserInfo: CurrentUserInfo
    isReviewer: boolean
    isAdmin: boolean
    isAuthor: boolean
    isSystemUser: boolean
    isInternalCmsUser: boolean
    isPublishingAuthor: boolean
    isBestPracticeEnabled: boolean
}

export const userInfoInitial: UserInfo = {
    currentUserInfo: {
        b2cUserId: '',
        kpUserId: '',
        roles: [],
        firstName: '',
        lastName: '',
        email: '',
        account: {
            accountId: '',
            accountType: '',
        },
    },
    isBestPracticeEnabled: false,
    isReviewer: false,
    isAdmin: false,
    isAuthor: false,
    isSystemUser: false,
    isInternalCmsUser: false,
    isPublishingAuthor: false,
}

export const userInfo = makeVar<UserInfo>({
    ...userInfoInitial,
})

export const setUser = (user: CurrentUserInfo) => {
    userInfo({
        ...userInfoInitial,
        currentUserInfo: user,
        isReviewer: user.roles.includes('Reviewer'), // Only true for Onboarder user
        isAdmin: AdminBaseRoles.includes((user.roles[0] ?? '') as Role),
        isAuthor: user.roles.includes('Author'),
        isSystemUser: user?.account?.accountType === 'System', // True only for Deltek users
        isInternalCmsUser: user?.account?.accountType === 'System',
        isPublishingAuthor:
            user.roles.includes('PublishingAuthor') ||
            user.roles.includes('Author'), // This is true for Deltek and AE author users
    })
}

export const setIsBestPracticeEnabled = (isBestPracticeEnabled: boolean) => {
    userInfo({
        ...userInfo(),
        isBestPracticeEnabled,
    })
}
